import { ApiResponse, TokenData, IFinanceOwingBank } from '../models';
import * as http from './http';
import ApiService from './service';

export class FinanceOwingBankService extends ApiService {
  public async loadAllFinanceOwingBanks(): Promise<IFinanceOwingBank[]> {
    const url = `${this.apiDomain}/api/trade-in/finance-owing-bank`;

    const resposne = await http.get<ApiResponse<IFinanceOwingBank[]>>(
      url,
      this.store
    );
    return resposne?.data?.data;
  }

  public async updateFinanceOwingBank(data: IFinanceOwingBank, id?: string) {
    const url = `${this.apiDomain}/api/trade-in/finance-owing-bank/${id}`;

    const response = await http.put<ApiResponse<IFinanceOwingBank>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async createFinanceOwingBank(data: IFinanceOwingBank) {
    const url = `${this.apiDomain}/api/trade-in/finance-owing-bank`;

    const response = await http.post<ApiResponse<IFinanceOwingBank>>(
      url,
      data,
      this.store
    );
    return response.data;
  }

  public async deleteFinanceOwingBank(id?: string) {
    const url = `${this.apiDomain}/api/trade-in/finance-owing-bank/${id}`;

    const response = await http.remove<ApiResponse<IFinanceOwingBank>>(
      url,
      this.store
    );
    return response.data;
  }
}
